import { useQuery } from "@tanstack/react-query";
import apiClient from "@/modules/request.module.v2";
import { useCompanyIdFromUrl } from "@/hooks/companies/useCompanyIdFromUrl";
const useStripePublicApiKey = () => {
  const companyId = useCompanyIdFromUrl();

  return useQuery({
    staleTime: Infinity, // We only want to the API key once
    queryKey: ["stripePublicApiKey"],
    queryFn: () => {
      return apiClient.get(`subscriptions/public_api_key`, {
        params: { companyId },
      });
    },
  });
};

export { useStripePublicApiKey };
